<template>
    <div class="order-item">
        <div class="order-item-head">
            <div>{{item.type === 2 ? '精品路线' : '接机服务'}}</div>
            <div class="ml-20">发布于：{{item.reception_time}}</div>
            <div class="ml-a color-red">{{stateName}}</div>
        </div>
        <div class="order-body">
            <!--<img class="order-body-img" :src="`/api/v1/file/${item.driver_portrait}`" alt="">-->
            <div class="order-content">
                <el-form label-width="100px" label-position="right">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;" label="订单编号：">{{item.out_trado_no}}</el-form-item>
                            <el-form-item v-if="item.flight" style="margin-bottom: 0;" label="航班号：">{{item.flight}}
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="到达终点：">{{item.address}}</el-form-item>
                            <el-form-item v-if="item.type===3" style="margin-bottom: 0;" label="开始时间：">
                                {{item.time}}
                            </el-form-item>
                            <el-form-item v-else style="margin-bottom: 0;" label="接机时间：">
                                {{item.reception_time}}
                            </el-form-item>
                            <el-form-item v-if="item.type===3" style="margin-bottom: 0;" label="结束时间：">
                                {{item.time_two}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;" label="人数：">{{item.people}}人</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="行李：">{{item.bags}}件</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="付款金额：">
                                <span class="color-red">{{+item.price_all|parseMoney}}</span>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="留言备注：">{{item.remark}}</el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="order-btn">
                <el-button v-if="item.order_state === 1" size="mini" type="success">立即支付</el-button>
                <el-button v-if="item.order_state === 1 || item.order_state === 2" @click="$emit('cancel')" size="mini" type="warning">取消订单</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrderShuttle",
        props: {
            item: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped lang="less">
    .order-item {
        border-radius: 6px;
        overflow: hidden;
        margin-bottom: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

        .order-item-head {
            width: 100%;
            height: 44px;
            background-color: #f5f5f5;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 20px;
            font-size: 14px;
            box-sizing: border-box;
        }

        .order-body {
            padding: 20px;
            box-sizing: border-box;
            background-color: #ffffff;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;

            .order-body-img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                border-radius: 6px;
                margin-right: 20px;
            }
        }

        .order-content {
            flex: 1;
            height: 100%;
        }

        .order-btn {
            width: 200px;
            margin-top: auto;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>
